import {Box, Stack} from '@mui/material';
import {
	BookingScheduledEnum,
	MotorV2Enums,
	OdontoBookingTaggingEnum,
} from 'main/analytics/gaTagsEnum';
import {AlertModal, CTAButtonFixed, DataInfo} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {useExamConfirmationBooking} from '../../hooks/useExamConfirmationBooking';
import {ExamConfirmBookingButtonProps} from './types';

const {
	confirmBooking,
	confirmationBooking,
	errorExamBookingTitle,
	successExamBookingDescription,
	successExamBookingAlert,
	successExamBookingHeaderTitle,
	unavailableSchedule,
} = translations['pt-br'].privateFlow.bookingFlow;
const {goBack, pleaseTryAgain, agreementText} = translations['pt-br'].commons;
const {appointmentProtocol} =
	translations['pt-br'].privateFlow.myAppointments.myAppointmentDetails.appointmentInstructions;

export function ExamConfirmBookingButton({handleBack}: ExamConfirmBookingButtonProps) {
	const {
		handleBookingAction,
		isSubmitting,
		isGenericError,
		isHideConfirmationBookingModalEnabled,
		isDone,
		dataTagIdSuccess,
		handleCloseSuccessDialogState,
		isUnavailable,
		handleCloseAndRedirectToSchedule,
		isMobile,
		setBookingState,
		protocolNumber,
		alertModalpaperStyles,
	} = useExamConfirmationBooking({handleBack});

	return (
		<Fragment>
			<CTAButtonFixed.Root>
				<Stack
					gap={1}
					direction={isMobile ? 'column-reverse' : 'row'}
					justifyContent="flex-end">
					<CTAButtonFixed.Action
						data-tag-id={
							OdontoBookingTaggingEnum.CLICK_VOLTAR_STEP_CONFIRMAR_AGENDAMENTO
						}
						fullWidth={isMobile}
						onClick={handleBack}
						size="large"
						variant="outlined">
						{goBack}
					</CTAButtonFixed.Action>
					<CTAButtonFixed.Action
						data-tag-id={BookingScheduledEnum.CLICK_CONFIRMAR_AGENDAMENTO_EXAME}
						fullWidth={isMobile}
						onClick={handleBookingAction}
						endIcon={isSubmitting ? <Loading color="inherit" size={16} /> : null}
						disabled={isSubmitting}
						size="large">
						{confirmBooking}
					</CTAButtonFixed.Action>
				</Stack>
			</CTAButtonFixed.Root>

			<AlertModal
				slotProps={{
					paper: alertModalpaperStyles,
				}}
				description={pleaseTryAgain}
				headerTitle={confirmationBooking}
				title={errorExamBookingTitle}
				onClose={() => setBookingState(null)}
				open={isGenericError}
				variant="info"
			/>

			{isHideConfirmationBookingModalEnabled ? null : (
				<AlertModal
					slotProps={{
						paper: alertModalpaperStyles,
					}}
					subDescription={
						<Box alignSelf="center">
							<DataInfo
								primaryText={appointmentProtocol}
								secondaryText={protocolNumber}
								iconName="assignment-filled"
							/>
						</Box>
					}
					headerDataTagId={dataTagIdSuccess}
					buttonDataTagId={
						OdontoBookingTaggingEnum.CLICK_ENTENDI_MODAL_CONFIRMACAO_AGENDAMENTO
					}
					description={successExamBookingDescription}
					title={successExamBookingAlert}
					headerTitle={successExamBookingHeaderTitle}
					open={isDone}
					onClose={handleCloseSuccessDialogState}
					variant="success"
					buttonLabel={agreementText}
				/>
			)}

			<AlertModal
				slotProps={{
					paper: alertModalpaperStyles,
				}}
				description={unavailableSchedule.description}
				headerTitle={unavailableSchedule.title}
				buttonLabel={unavailableSchedule.button}
				onClose={handleCloseAndRedirectToSchedule}
				open={isUnavailable}
				variant="info"
				data-tag-id={MotorV2Enums?.V2_ERRO_HORARIO}
				buttonDataTagId={MotorV2Enums?.V2_CLICK_CTA_ERRO_HORARIO}
			/>
		</Fragment>
	);
}
